var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('v-link',{attrs:{"href":"/music"}},[_c('img',{attrs:{"alt":"Tequila Tears - Andy Frantz","src":require("../assets/TequilaTearsCover_lowres.jpeg"),"width":"100%"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }